import { LogEventPlatform } from '@akin-home/amplify';
import { Platform } from 'react-native';

const PLATFORM_MAP: { [key: string]: LogEventPlatform } = {
  android: LogEventPlatform.ANDROID,
  ios: LogEventPlatform.IOS,
  web: LogEventPlatform.WEB,
};

const platform = PLATFORM_MAP[Platform.OS] || LogEventPlatform.ANDROID;

export const getLogEventPlatform = () => platform;
